module.exports = __webpack_public_path__ + "img/register-img.ad41e41.png";